import { CheckCircleIcon, InProgressIcon, PendingClockIcon } from '@tractian/icons'
import type { ComponentType } from 'react'

export type AssessmentStatusKey = 'pending' | 'inProgress' | 'completed'

type AssessmentStatusVisual = {
  Icon: ComponentType<{ className?: string }>
  /** Tailwind text-color class for the icon — used by ag-grid table cells. */
  colorClass: string
  /** Same color as a CSS hex — used where inline `style` is required (ui-filters options). */
  colorHex: string
}

// colorClass and colorHex must stay in sync (amber-500 / blue-500 / emerald-500).
export const ASSESSMENT_STATUS_CONFIG: Record<AssessmentStatusKey, AssessmentStatusVisual> = {
  pending: { Icon: PendingClockIcon, colorClass: 'text-amber-500', colorHex: '#f59e0b' },
  inProgress: { Icon: InProgressIcon, colorClass: 'text-blue-500', colorHex: '#3b82f6' },
  completed: { Icon: CheckCircleIcon, colorClass: 'text-emerald-500', colorHex: '#10b981' }
}

export const ASSESSMENT_STATUS_ORDER: AssessmentStatusKey[] = ['pending', 'inProgress', 'completed']
